import * as TK from 'components/comments/CommentMenu/translations/constants';
import { Translations } from 'translations/types';

export const commentMenuEnUsLocale: Translations = {
  [TK.COMMENT_MENU_DELETE]: 'Delete',
  [TK.COMMENT_MENU_DELETION_DIALOG_MESSAGE]: 'Are you sure you want to delete this comment?',
};
